import EmailTemplateButtonGroup from '@/components/Drawer/EmailTemplateButtonGroup'
import {HtmlPreview} from '@/shared-components/HtmlPreview'
import {MessageTemplateDrawerStatusEnum} from '@/types/MessageTemplateDrawerStatusEnum'
import {useIntl} from 'react-intl'

interface Props {
  country: string
  templateName: string
  category: string
  templateMessage: string
  updateDrawerStatus: (value: MessageTemplateDrawerStatusEnum) => void
  sendEmailTemplateDraft: () => void
  sendEmailTemplate: () => void
}

export default function EmailTemplatePreview({
  country,
  templateName,
  category,
  templateMessage,
  updateDrawerStatus,
  sendEmailTemplateDraft,
  sendEmailTemplate,
}: Props): React.JSX.Element {
  const {formatMessage} = useIntl()

  return (
    <div data-testid="email-template-preview-page" className="ml-2 flex w-full flex-col items-start px-1">
      <div className="mb-4 text-lg font-bold text-text-primary">
        {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_PREVIEW'})}
      </div>
      <div className="w-full">
        <div className="border-b border-border-gray">
          <div className="pt-3 text-xs font-bold text-text-secondary">
            {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.COUNTRY_LABEL'})}
          </div>
          <div className="pb-3 pt-1 text-xs text-text-primary">{country}</div>
        </div>
        <div className="border-b border-border-gray">
          <div className="pt-3 text-xs font-bold text-text-secondary">
            {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_NAME'})}
          </div>
          <div className="pb-3 pt-1 text-xs text-text-primary">{templateName}</div>
        </div>
        <div className="border-b border-border-gray">
          <div className="pt-3 text-xs font-bold text-text-secondary">
            {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_CATEGORY'})}
          </div>
          <div className="pb-3 pt-1 text-xs text-text-primary">{category}</div>
        </div>
      </div>
      <div className="mt-4 w-full">
        <div className="pb-2 text-xs font-bold text-text-secondary">
          {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_PREVIEW'})}
        </div>
        <HtmlPreview html={templateMessage} data-testid="email-template-preview" />
      </div>
      <EmailTemplateButtonGroup
        testIdPrimary="email-template-publish"
        testIdSecondary="email-template-save-as-draft"
        testIdTertiary="email-template-preview-back"
        primaryButtonLabel={formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.PUBLISH_BUTTON_LABEL'})}
        secondaryButtonLabel={formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.SAVE_AS_DRAFT_BUTTON_LABEL'})}
        tertiaryButtonLabel={formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.BACK_BUTTON_LABEL'})}
        onClickPrimary={sendEmailTemplate}
        onClickSecondary={sendEmailTemplateDraft}
        onClickTertiary={() => updateDrawerStatus(MessageTemplateDrawerStatusEnum.createEmailTemplate)}
      />
    </div>
  )
}
